import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { loadOnboardingEmail, RegistrationService, saveOnboardingEmail } from '../registration.service';

@Component({
    selector: 'app-signup-done',
    standalone: false,
    templateUrl: './signup-done.component.html',
    styleUrls: ['./signup-done.component.css']
})
export class SignupDoneComponent implements OnInit {
  public stage = '';
  public email = '';
  public tenantId = '';
  public resendInFlight = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly registrationService: RegistrationService,
    private readonly snackbar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.stage = this.route.snapshot.queryParamMap.get('stage') ?? '';
    this.tenantId = this.route.snapshot.queryParamMap.get('tenantId') ?? '';
    const stateTenantInfo = history.state?.tenantInfo;
    const stateEmail = typeof stateTenantInfo?.emailAddress === 'string' ? stateTenantInfo.emailAddress.trim() : '';
    this.email = stateEmail || loadOnboardingEmail(this.tenantId) || '';
    saveOnboardingEmail(this.tenantId, this.email);
  }

  resendVerification(): void {
    if (!this.tenantId || this.resendInFlight) {
      return;
    }

    this.resendInFlight = true;
    this.registrationService.resendVerification(this.tenantId).subscribe({
      next: () => {
        this.resendInFlight = false;
        this.snackbar.open('Verification email sent.', 'OK');
      },
      error: (err) => {
        this.resendInFlight = false;
        const reason = err?.error?.error || 'Unable to resend the verification email.';
        this.snackbar.open(reason, 'OK');
      },
    });
  }
}
